import moment from "moment";
import { FORM_NAMS, FORM_NAMS_WITHOUT_HYPHEN } from "../../web/businesslogic/formssection/manageforms/managefederalforms/statefiling/constants";
import { BADGE_COLOR } from "../../web/components/badge/constants";
import { USER_TYPE } from "../customhooks/constants";
import DateUtils from "./DateUtils";
import { FORM_FIELD_NAME_TEXT, FORM_FIELD_VALIDATION_REGEX, INTERNAL_USER_EMAIL_DOMAINS, PERFTEST_EMAIL_DOMAIN, FORMAT_ZIP_CODE_REGEX, VALIDATE_NAME_REGEX } from "./constants";
import Config from "../../web/config.web";
import UrlEncodeDecode from "../txsearchparams/urlEncodeDecode";

export default class General {

    static addOptionAndValueKeys(arr, labelExtracterKey, valueExtracterKey) {
        arr.map(item => {
            const label = item[labelExtracterKey];
            item.label = typeof label === 'string' ? label : String(label);
            item.value = item[valueExtracterKey];
        })
    }

    static convertFieldNamesToObjKeys(allFields) {
        return allFields.reduce((result, item) => {
            result[item.Name] = item;
            return result;
        }, {});
    }

    static formatCardNumber(cardNumber) {
        let digitsOnly = cardNumber.replace(/\D/g, '');

        let maskedNumber = 'X'.repeat(12) + digitsOnly.slice(12);

        let groupedDigits = [];
        let remainingDigits = maskedNumber;
        while (remainingDigits.length > 4) {
            groupedDigits.push(remainingDigits.substr(0, 4));
            remainingDigits = remainingDigits.substr(4);
        }

        groupedDigits.push(remainingDigits);

        let formattedNumber = groupedDigits.join('-');

        return formattedNumber;
    }

    static checkErrorsExist(obj) {
        for (let key in obj) {
            if (obj.hasOwnProperty(key) && obj[key] !== '') {
                return true;
            }
        }
        return false;
    }
    static handleFileUpload(event, isDropEvent) {
        event.preventDefault();
        const file = isDropEvent ? event.dataTransfer.files[0] : event.target.files[0];
        const allowedFileTypes = ['.xlsx', '.csv'];
        if (file) {
            const fileExtension = file.name.split('.').pop().toLowerCase();
            if (allowedFileTypes.includes(`.${fileExtension}`)) {
                return file;
            } else {
                return null;
            }
        }
        else {
            return null;
        }
    };


    static extractNumber(string) {
        const numberRegex = /\$\d+(?:\.\d+)?/;
        const match = string.match(numberRegex);
        if (match) {
            const numberString = match[0].replace("$", "");
            return parseFloat(numberString);
        } else {
            return null;
        }
    }

    static base64ToBlob(base64Data, contentType = 'application/octet-stream') {
        const byteCharacters = atob(base64Data);
        const byteArrays = [];
        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
            const slice = byteCharacters.slice(offset, offset + 512);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        return new Blob(byteArrays, { type: contentType });
    };

    static downloadFile(data, fileName, contentType) {
        const blob = General.base64ToBlob(data, contentType);
        const downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = fileName;
        downloadLink.click();
    };

    static downloadFileWithBase64AndName(exportFile) {
        if (exportFile.hasOwnProperty('Name') && exportFile.hasOwnProperty('Base64')) {
            this.downloadFile(exportFile.Base64, exportFile.Name)
        }
    }

    static downloadFileFromBase64(base64String, fileName) {
        const extension = fileName.split('.').pop();
        let mimeType = '';

        switch (extension.toLowerCase()) {
            case 'txt': mimeType = 'text/plain';
                break;
            case 'pdf': mimeType = 'application/pdf';
                break;
            case 'docx': mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
                break;
            case 'xlsx': mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                break;
            case 'csv': mimeType = "data:text/csv"
                break;
            case 'zip': mimeType = 'application/zip';
                break;

            default: mimeType = 'application/octet-stream'; break;
        }

        const link = document.createElement('a');
        link.href = `data:${mimeType};base64,${base64String}`;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    static openBase64FileInNewTab(base64String, fileName) {
        const extension = fileName.split('.').pop();
        let mimeType = '';

        switch (extension.toLowerCase()) {
            case 'txt': mimeType = 'text/plain';
                break;
            case 'pdf': mimeType = 'application/pdf';
                break;
            case 'docx': mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
                break;
            case 'xlsx': mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                break;
            case 'csv': mimeType = "data:text/csv"
                break;
            case 'zip': mimeType = 'application/zip';
                break;

            default: mimeType = 'application/octet-stream'; break;
        }

        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: mimeType });

        const objectURL = URL.createObjectURL(blob);

        window.open(objectURL, '_blank', 'noopener');

        URL.revokeObjectURL(objectURL);
    }

    static tinStatusColor(type) {
        switch (type.toLowerCase()) {
            case 'processing':
                return BADGE_COLOR.PRIMARY;
            case 'blocked':
                return BADGE_COLOR.DANGER;
            case 'active':
                return BADGE_COLOR.PRIMARY;
            case 'in-active':
                return BADGE_COLOR.DANGER;
            default:
                return BADGE_COLOR.PRIMARY;
        }
    }

    static hasAccessToUserType(currentUserType, allowedUserTypes) {
        if (allowedUserTypes.length === 0) {
            return true
        }

        return allowedUserTypes.includes(currentUserType);
    }

    static getUserType(userPlanName) {
        return USER_TYPE[userPlanName];
    }

    static removeDashesFromString(inputString) {
        return inputString.replace(/-/g, '');
    }

    static getDomainWithProtocolFromUrl(url) {
        const parser = document.createElement('a');
        parser.href = url;
        return `${parser.protocol}//${parser.hostname}/`;
    }

    static validateName(name) {
        if (!VALIDATE_NAME_REGEX.test(name)) {
            return false
        }
        if (name.length === 0 || name.length > 40) {
            return false
        }
        return true
    }

    static checkFederalFormsStateFiling(arr) {

        arr.forEach(elem => {
            const formName = elem?.FormName;

            if (formName !== FORM_NAMS.$1095_B ||
                formName !== FORM_NAMS.$1095_C ||
                formName !== FORM_NAMS.$1099_B ||
                formName !== FORM_NAMS.$1099_K ||
                formName !== FORM_NAMS.$1099_MISC ||
                formName !== FORM_NAMS.$1099_NEC ||
                formName !== FORM_NAMS.$1099_R ||
                formName !== FORM_NAMS.W_2 ||
                formName !== FORM_NAMS_WITHOUT_HYPHEN.$1095_B ||
                formName !== FORM_NAMS_WITHOUT_HYPHEN.$1095_C ||
                formName !== FORM_NAMS_WITHOUT_HYPHEN.$1099_B ||
                formName !== FORM_NAMS_WITHOUT_HYPHEN.$1099_K ||
                formName !== FORM_NAMS_WITHOUT_HYPHEN.$1099_MISC ||
                formName !== FORM_NAMS_WITHOUT_HYPHEN.$1099_NEC ||
                formName !== FORM_NAMS_WITHOUT_HYPHEN.$1099_R ||
                formName !== FORM_NAMS_WITHOUT_HYPHEN.W_2) {
                return false;
            }
        })

        return true;
    }

    static filterFormsByName(Data, filterFormName) {
        const filteredArray = Data.filter(item => {
            return filterFormName.includes(item.FormName1)
        })
        return filteredArray;
    }

    static sanitizeContent(content) {
        const allowedTags = ['br', 'h5', 'h6', 'b'];
        const pattern = new RegExp(`<(${allowedTags.join('|')})\\b[^>]*>`, 'gi');

        const replacedContent = content.replace(pattern, (match) => match.toLowerCase());
        const finalContent = replacedContent.replace(/\\r\\n/g, '\n').replace(/\\n/g, '\n').replace(/\\t/g, '\t');

        return finalContent.replace(/\n/g, '<br>');
    }

    static isDateInPast(dateString) {
        const now = DateUtils.getStartOf('day');
        const dateToCheck = DateUtils.getMomentDate(dateString, 'MM/DD/YYYY').startOf('day');

        return dateToCheck.isBefore(now) || dateToCheck.isSame(now);
    }

    static getTotalFromDollarStringArray(arr) {
        return arr.reduce((acc, val) => {
            const num = parseFloat(val.replace(/[^0-9.]/g, ''));
            return acc + num;
        }, 0);
    }

    static formatNameAsPossessive(str) {
        if (!str) return '';

        // If the string ends with an 's', keep it as it is, Otherwise, append 's'
        return str.endsWith('s') ? `${str}` : `${str}'s`;
    }

    static getDecimalAmount(amount) {
        if (("" + amount).trim() == "") {
            return 0;
        }
        return (amount && amount?.toFixed) ? amount?.toFixed(2) : amount;
    }

    static getNumberAmount(amount) {
        return amount ? Number(amount.toString().replace(",", "")) : 0
    }

    static shouldChangeScheduleDisabled() {
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth() + 1; // getMonth() returns a zero-based value (0-11)

        if (currentMonth >= 6 && currentMonth < 11) {
            return true;
        } else {
            return false;
        }
    }

    static checkReferenceNumbers(arr) {
        if (!arr?.length) {
            return false;
        }

        const firstRefNumber = arr[0].ReferenceNumber;

        for (let item of arr) {
            if (item.ReferenceNumber !== firstRefNumber) {
                return false;
            }
        }
        return true;
    }

    static transformToPaymentAddress = (data) => {
        return {
            address: {
                line1: data?.Address?.value || "",
                city: data?.City?.value || "",
                country: data?.Country?.value || "",
                email: data?.Email?.value || "",
                state: data?.State?.value || "",
                postal_code: data?.ZIP?.value || "",
            }
        }
    }

    static disablePaymentFeature = (year, formId) => {
        if (year == 2023) {
            switch (formId) {
                case FORM_NAMS.Form941:
                    return false;

                case FORM_NAMS.Form941PR:
                    return false;

                default:
                    return false; //Make this as true when you want to disable payments on form listing screen for specific year
            }
        } else {
            return false;
        }
    }

    static STATE_FORMS = {
        '1099MISC': '1099MISC',
        '1099NEC': '1099NEC',
        '1099K': '1099K',
        '1099B': '1099B',
        '1099R': '1099R',
        'W2': 'W2'
    }

    static MULTIPAYER_SUBMIT_DISABLED_FORMS = {
        "W-2VI": "W-2VI",
        "W-2GU": "W-2GU",
        "W-2G": "W-2G"
    }

    static isStateForm = (formName) => {
        return this.STATE_FORMS[formName] ? true : false
    }

    static is94xForm = (forms94xList, formName) => {
        return forms94xList[formName]
    }

    static isFormExist = (formsList, formName) => {
        return formsList[formName]
    }

    static getCurrentEnv = () => {
        return Config.ENV;
    }

    static encodeString = (str) => {
        if (!str && typeof str !== 'string') {
            return null
        }
        let encodedStr = encodeURIComponent(str)

        return encodedStr
    }

    static decodeString = (str) => {
        if (!str && typeof str !== 'string') {
            return null
        }
        let decodedStr = decodeURIComponent(str)

        return decodedStr
    }

    static sanitizeNumberInput = ({ number, errors, maxLength = 20 }) => {
        if (!number) {
            return {
                number: null
            }
        }

        number = number.toString()
        const input = number.replace(/[^0-9.]|\.(?=.*\.)/g, '');

        if (input.length <= maxLength) {
            return { number: input }
        } else {
            return { number: input.slice(0, maxLength), errors: { ...(errors || {}), message: `Please enter the number less than ${maxLength} digits` } }
        }
    }

    static getUserDomain = (email) => {
        if (!email) {
            return
        }
        email = email.toString().toLowerCase()

        if (email.includes(PERFTEST_EMAIL_DOMAIN)) {
            return PERFTEST_EMAIL_DOMAIN
        } else if (email.includes(INTERNAL_USER_EMAIL_DOMAINS.ZENWORK)) {
            return INTERNAL_USER_EMAIL_DOMAINS.ZENWORK
        } else if (email.includes(INTERNAL_USER_EMAIL_DOMAINS.TAX1099)) {
            return INTERNAL_USER_EMAIL_DOMAINS.TAX1099
        } else {
            return null
        }
    }

    static convertObjToQueryString = (data) => {
        return Object.entries(data).filter(([key, val]) => val !== undefined && val !== null).map(([key, val]) => `${key}=${encodeURIComponent(val)}`).join('&');
    };

    static convertQueryStringToObj = (url) => {
        const params = {};
        const queryString = url.split('?')[1];

        if (queryString) {
            queryString.split('&').map(pair => {
                const [key, value] = pair.split('=');
                params[key] = decodeURIComponent(value || '');
            });
        }

        return params;
    }

    static removeExtraSpaces = (str) => {
        return str.replace(/\s+/g, ' ').trim();
    }

    static displayPayerRecipientName = (obj) => {
        return (
            General.removeExtraSpaces(obj?.FirstName && obj?.LastName
                ? `${obj.FirstName} ${obj?.MiddleName ?? ""} ${obj.LastName}`
                : obj?.Name
                    ? obj.Name
                    : obj?.LastName
                        ? `${obj.LastName}`
                        : ""
            ));
    }

    static extractIntegerFromString(str) {
        const pattern = /\d+/;

        const matches = str.match(pattern);
        if (matches) {
            const number = parseInt(matches[0]);
            return number;
        } else {
            return 0;
        }
    }

    static extractPaginationTotalFromResponse(data) {
        if (data?.Data?.Total) {
            return data.Data.Total
        } else if (data?.Data?.total) {
            return data.Data.total
        } else {
            if (data?.Message) {
                return this.extractIntegerFromString(data.Message)
            }
        }

        return 0;

    }

    static convertObjStringToObject(objString = "{}") {
        const jsonObject = objString.replace(/(['"])?([a-zA-Z0-9_]+)(['"])?:/g, '"$2": ');

        return JSON.parse(jsonObject)
    }

    static validateInputWithRegex(e, validateSuccessCb = () => { }) {
        const { name, value } = e.target || {};

        let regex = ""
        switch (name) {
            case FORM_FIELD_NAME_TEXT.FIRST_NAME_TEXT:
            case FORM_FIELD_NAME_TEXT.COMPANY_NAME_TEXT:
            case FORM_FIELD_NAME_TEXT.LAST_NAME_TEXT:
                regex = FORM_FIELD_VALIDATION_REGEX.NAME_FIELD_REGEX;
                break;
            case FORM_FIELD_NAME_TEXT.PHONE_NUMBER_TEXT:
            case FORM_FIELD_NAME_TEXT.PAYER_PHONE_NUM_TEXT:
            case FORM_FIELD_NAME_TEXT.RECIPIENT_PHONE_NUM_TEXT:
                regex = FORM_FIELD_VALIDATION_REGEX.PHONE_NUMBER_REGEX
                break
            default:
                return validateSuccessCb();
        }

        if (regex.test(value) || value === '') {
            return validateSuccessCb()
        }
    }

    static reorderArrayByActiveElementObj(array = [], activeObjKey = {}, compareWtVal = true) {
        const arrayClone = [...array]

        const index = arrayClone.findIndex(obj => obj[activeObjKey] === compareWtVal);

        if (index !== -1) {
            const activeObj = arrayClone.splice(index, 1)[0];
            arrayClone.unshift(activeObj);
        }
        return arrayClone
    }

    static arrayObjectsKeyIsNotEmpty(array = [], key = "") {
        return array?.every(record => record[key]) ? true : false
    }

    static formatZipCode = (input = "") => {
        if (input.length > 5 && input.length === 9) {
            return input.replace(FORMAT_ZIP_CODE_REGEX, "$1-$2");
        } else if (input.length >= 10) {
            return input.slice(0, 10)
        } else {
            return input
        }
    }

    static extractDataFromResponseData(responseData) {
        if (responseData?.Data?.hasOwnProperty("Data")) {
            return responseData.Data.Data
        } else {
            return responseData.Data
        }
    }

    static truncateWithEllipsis(text = "", maxLength = 10) {
        return text?.length > maxLength ? text.substring(0, maxLength) + '...' : text
    }

    static formatCurrency = (amount, currencyCode = 'USD', languageCode = 'en-US') => {
        return amount.toLocaleString(languageCode, { style: 'currency', currency: currencyCode });
    }

    static getLocalStorageItem = (key, defaultValue = null) => {
        try {
            const storedItem = localStorage.getItem(key);
            if (!storedItem) {
                return defaultValue;
            }

            const parsedItem = JSON.parse(storedItem);

            if (parsedItem.expiry) {
                const now = new Date().getTime();
                if (now > parsedItem.expiry) {
                    localStorage.removeItem(key);
                    return defaultValue;
                }
                return parsedItem.value;
            }

            return parsedItem.value !== undefined ? parsedItem.value : defaultValue;
        } catch (error) {
            console.error(`Error getting localStorage item: ${key}`, error);
            return defaultValue;
        }
    };

    static setLocalStorageItem = (key, value, ttl = null) => {
        try {
            const item = { value };

            if (ttl) {
                const now = new Date().getTime();
                item.expiry = now + ttl;
            }

            localStorage.setItem(key, JSON.stringify(item));
        } catch (error) {
            console.error(`Error setting localStorage item: ${key}`, error);
        }
    };

    static getFinalRouteToSignInPage = () => {
        let finalSignInRoute = "";
        const locationHash = window?.location?.hash?.split("#")[1] || null;
        if (locationHash) {
            const [route, query] = locationHash.split(`?${UrlEncodeDecode.STATE_NAME}=`);
            finalSignInRoute = query ? `${route}?${UrlEncodeDecode.decode(query)}` : route;
        }
        return General.encodeString(General.decodeString(finalSignInRoute))
    }

    static handleGRecaptchaToken = (token) => {
        return token ?? "sdfefsdfdsfdfrgwre23432r4gtg"
    }
   
}